import React, { useEffect, useState } from "react";
import DashboardLayout from "./DashboardLayout";
import CompactDashboard from "./LiveAnalytics";
export default function LivePositions() {

  return (
    <DashboardLayout>
      <div className="z-0 relative flex flex-col w-full h-full  bg-black font-inter">
       <CompactDashboard />
      </div>
    </DashboardLayout>
  );
}
